import styles from './LoadingState.module.css'

interface LoadingStateProps {
  label: string
  hint?: string
}

export function LoadingState({ label, hint }: LoadingStateProps) {
  return (
    <div className={styles.root} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden="true" />
      <div className={styles.copy}>
        <p className={styles.label}>{label}</p>
        {hint ? <p className={styles.hint}>{hint}</p> : null}
      </div>
    </div>
  )
}
